module.exports = __webpack_public_path__ + "img/봉은사역 맛집 1.b1c46fd0.png";